import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'theme/theme';

const StyledRow = styled.tr`
    height: 48px;
    min-height: 48px;
    font-size: 13px;
    border-bottom: 1px solid ${ theme.table.body.row.border };
    color: ${ theme.table.body.row.color };

    &:last-of-type {
        border-bottom: none;
    }

    &:hover {
        background-color: ${ theme.table.body.row.hover };

        td {
            a {
                color: inherit;
            }
        }
    }

    div {
        font-size: inherit;
        margin: 0;
    }
`;

const TableRow = (props) => {
    const {
        children,
        onClick,
    } = props;

    return (
        <StyledRow onClick={ onClick }>
            { children }
        </StyledRow>
    );
};

TableRow.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.node,
        PropTypes.array,
    ]).isRequired,
    onClick: PropTypes.func,
};

export default TableRow;



// WEBPACK FOOTER //
// ./src/components/ui/table/TableRow.js